
export const getSegmentedPath = (x1, y1, x2, y2) => {
    if (y2 > y1) {
        return [
            x1, y1,

            x1, (0.75*y1 + 0.25*y2),
            x1, (0.75*y1 + 0.25*y2 + 1),

            x1, (0.5*y1 + 0.5*y2),
            x1, (0.5*y1 + 0.5*y2 + 1),
            
            x2, (0.5*y1 + 0.5*y2),
            x2, (0.5*y1 + 0.5*y2 + 1),

            x2, (0.25*y1 + 0.75*y2 + 0),
            x2, (0.25*y1 + 0.75*y2 + 1),

            x2, y2-2,
            x2, y2];
    }  else {
        // dont wanna interect the node
        return [
            x1, y1,

            x1, y1 + 15,
            x1, y1 + 16,

            x1, y1 + 30,
            x1, y1 + 31,

            x1*0.5 + x2*0.5, y1 + 30,
            x1*0.5 + x2*0.5, y1 + 31,

            x1*0.5 + x2*0.5, (.5*y1 + .5*y2) + 30,
            x1*0.5 + x2*0.5, (.5*y1 + .5*y2) + 31,

            x1*0.5 + x2*0.5, y2 - 30,
            x1*0.5 + x2*0.5, y2 - 31,

            x2, y2 - 30,
            x2, y2 - 31,

            x2, y2 - 16,
            x2, y2 - 15,

            x2, y2 - 2,
            x2, y2];
    }
};
